module.exports = __webpack_public_path__ + "static/background-ccfb4435524bd60bcb7a1b2d653a1f53.jpg";